import useQuickAction from "../../hooks/useQuickAction";
import { useState } from "react";
import { PencilAltIcon, PlusIcon } from "@heroicons/react/solid";
import { useSearchParams } from "react-router-dom";
import AddDepartment from "./AddDepartment";
import { Button } from "../../components/ui";
import useGet from "../../hooks/read/useGet";
import useRead from "../../hooks/useRead";
import Spinner from "../../components/loader/Spinner";
import EditDepartment from "./EditDepartment";
import RoundedContainer from "../../components/containers/RoundedContainer";
import Pagination from "../../components/pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";

function Department() {
  const [openDepartmentModal, setOpenDepartmentModal] = useState(false);
  const [openDepartmentAddModal, setOpenDepartmentAddModal] = useState(false);
  useQuickAction("add-department", () => setOpenDepartmentAddModal(true));
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedDepartment, setSelectedDepartment] = useState({});
  const initialDepartmentState = {
    limit: 10,
    search_query: searchParams.get("search_query") || "",
    page_number: searchParams.get("page_number") || 0,
  };
  const { list: shiftList } = useRead({
    url: "shift_listing",
    method: "GET",
    initialData: {
      limit: 50,
      search_query: "",
    },
  });

  const {
    list: departmentListing,
    paramsObject,
    setGetListParams,
  } = useGet({
    url: "department_listing",
    initialData: initialDepartmentState,
  });

  const handleOpenEditModal = (id) => {
    let departmentData = departmentListing?.data?.data;
    let filteredDepartment = departmentData.find((x) => x.id === id);
    setSelectedDepartment(filteredDepartment);
    setOpenDepartmentModal(true);
  };

  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      page_number: val.selected,
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  return (
    <div className="py-10">
      {(shiftList.isLoading || departmentListing.isLoading) && <Spinner />}
      <div className="px-4 flex items-center justify-end">
        <Button onClick={() => setOpenDepartmentAddModal(true)}>
          <PlusIcon className="w-4 h-4 mr-2" />
          Add Department
        </Button>
      </div>
      <RoundedContainer className="mx-4">
        {!departmentListing.data?.data?.length ? (
          <div className="text-center py-12">
            <p className="text-gray-700 text-2xl font-semibold mb-2">No Departments To Show</p>
            <p className="text-gray-500 text-sm mb-5">Create departments for your organization to organize your workforce.</p>
            <Button onClick={() => setOpenDepartmentAddModal(true)}>
              <PlusIcon className="w-4 h-4 mr-2" />
              Add Department
            </Button>
          </div>
        ) : (
          <div className="max-w-full overflow-x-auto">
            <Table className="table-auto w-full">
              <TableHead>
                <TableHeaderCell className="w-[10%] text-center">
                  Sr.no
                </TableHeaderCell>
                <TableHeaderCell className="w-[70%]">
                  Department Name
                </TableHeaderCell>
                <TableHeaderCell className="w-[20%] text-center">
                  Modify
                </TableHeaderCell>
              </TableHead>
              <TableBody>
                {departmentListing.data?.data?.map((item, idx) => {
                  const { departmentName, id } = item;
                  return (
                    <TableRow key={id}>
                      <TableCell className="text-dark font-medium text-sm text-center">
                        {paramsObject?.page_number * paramsObject?.limit + idx + 1}
                      </TableCell>
                      <TableCell className="text-dark font-medium text-sm">
                        {departmentName}
                      </TableCell>
                      <TableCell className="text-center">
                        <div
                          className="w-6 h-6 cursor-pointer mx-auto"
                          onClick={() => handleOpenEditModal(id)}
                        >
                          <PencilAltIcon className="text-gray-500 w-full h-full hover:text-primary transition-colors" />
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        )}
      </RoundedContainer>

      {!!departmentListing.data?.data?.length && (
        <RoundedContainer className="mx-4 mt-4">
          <Pagination
            currentPage={+paramsObject?.page_number || 0}
            lengthofItems={departmentListing.data?.total_count}
            limit={paramsObject?.limit || initialDepartmentState.limit}
            onPageChange={handlePageClick}
          />
        </RoundedContainer>
      )}

      {openDepartmentModal && (
        <EditDepartment
          open={openDepartmentModal}
          shiftData={shiftList?.data?.data}
          onClose={() => setOpenDepartmentModal(false)}
          selectedDepartment={selectedDepartment}
        />
      )}
      {openDepartmentAddModal && (
        <AddDepartment
          shiftData={shiftList?.data?.data}
          open={openDepartmentAddModal}
          onClose={() => setOpenDepartmentAddModal(false)}
        />
      )}
    </div>
  );
}

export default Department;
